/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

export default class MinMaxScaler {
	/**
	 * 
	 * @param {Object} tensor
	 * @constructor
	 */
	constructor(t) {
		this.min = t.min()
		this.max = t.max()
	}

	/** 
	 * Scale data from 0-1 based on fitting 
	 *
	 * @param {tf.tensor} t: tensor to transform
	 * @returns {tf.tensor} normalized tensor
	 */
	transform(t) {
		// t' = (t - min)/ (max - min)
		return t.sub(this.min).div(this.max.sub(this.min))
	}

	/** 
	 * Descale data to orginal scaling
	 *
	 * @param {tf.tensor} t: tensor to transform
	 * @returns {tf.tensor} denormalized tensor
	 */
	inverseTransform(t) {
		// t = (t' * (tmax - tmin)) + tmin
		return t.mul(this.max.sub(this.min)).add(this.min)
	}
}